import { Row } from 'app/design/primitives/box';

import { PlaceholderLine } from 'app/overrides/rn-placeholder/PlaceholderLine';
import { Shine } from 'app/overrides/rn-placeholder/animations/Shine';
import React from 'react';
import { View } from 'react-native';
import { QUICK_ACTION_CARD_HEIGHT } from './quick-action-card';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

function QuickActionCardSkeleton() {
  return (
    <View
      style={{
        flex: 1,
        height: QUICK_ACTION_CARD_HEIGHT,
        padding: theme.spacing['spacing.general.x4'],
        backgroundColor: theme.colors['surface.default'],
        borderRadius: theme.borderRadii['radius.lg'],
        borderWidth: 1,
        borderColor: theme.colors['surface.inverse.tertiary-neutral'],
      }}
    >
      <PlaceholderLine
        noMargin
        height={16}
        style={{ width: '60%', borderRadius: 4, marginBottom: theme.spacing['spacing.general.x2'] }}
      />
      <PlaceholderLine noMargin height={12} style={{ width: '85%', borderRadius: 4 }} />
    </View>
  );
}

export function QuickActionsSkeleton() {
  return (
    <Shine reverse={false}>
      <Row gap="spacing.general.x4">
        <QuickActionCardSkeleton />
        <QuickActionCardSkeleton />
      </Row>
    </Shine>
  );
}
